// extracted by mini-css-extract-plugin
export default {"icon":"EventNotificationsItem-module-b2c0b491947c8e04e02a","unread":"EventNotificationsItem-module-c2f7ea6a5d6fce1fe283"};